export default {
	rules: {
		required: "Indication requise",
		requiredTrailingSpace: "Indication requise. ",
		onlyWhitespace: "La saisie ne doit pas contenir uniquement des espaces.",
		maxLength35: "35 caractères maximum autorisés.",
		maxLength50: "50 caractères maximum autorisés.",
		maxLength50TrailingSpace: "50 caractères maximum autorisés. ",
		invalidCharacters: 'Contient des caractères non autorisés "* ^ { } [ ] = < > |"',
		invalidEmail: "Doit être une adresse e-mail valide. ",
		notANumber: "Doit être un nombre.",
		mustBePositive: "Doit être positif.",
		noDecimals: "Aucune décimale autorisée",
		notAnInteger: "Doit être un nombre entier.",
		outOfRange0To1000: "Doit être compris entre 0 et 1000",
	},
	messages: {
		allUsers: "Tous les utilisateurs",
		savedCartQuantitySet:
			"La quantité de l'article {articleId} a été fixée à {quantity} pce. dans la liste de pièces.",
		savedCartQuantityError: "Impossible de modifier la quantité.",
		savedCartRemoveArticleError: "Impossible de retirer l'article de la liste de pièces.",
		savedCartAddArticleError: "Impossible d'ajouter l'article à la liste de pièces.",
		addressDeleted: "L'adresse a été supprimée.",
		addressDeleteError: "Impossible de supprimer l'adresse.",
		addressSetPreferred: "L'adresse a été définie comme favorite.",
		addressSetPreferredError: "Impossible de définir l'adresse comme favorite.",
		weldlineOne: "1 cordon de soudure",
		weldlineMultiple: "{count} cordons de soudure",
		cornerOne: "1 angle",
		cornerMultiple: "{count} angles",
		cleaned: "poli",
		notCleaned: "non poli",
		powderFinishMatt: "Mat",
		powderFinishGlossy: "Brillant",
		notAvailable: "Non disponible",
		powderStructureSmooth: "Lisse",
		powderStructureFine: "Fin",
		powderStructureRough: "Grossier",
	},
};
